/*
 * The category bar's panels.
 *
 * CSS alone opens them on hover, which leaves out touch (no hover at all) and
 * makes the menu impossible to verify. This opens on hover, on click and on
 * keyboard focus, closes on Escape or a click outside, and keeps aria-expanded
 * honest. With JavaScript off, the CSS hover rules still work.
 */
(function () {
  // The theme loads this from <head>, so the nav does not exist yet.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  function start() {
  var OPEN = 'is-open';
  var items = [].slice.call(document.querySelectorAll('.sb-nav__item[data-sb-nav]'));
  if (!items.length) return;

  function panelOf(item) { return item.querySelector('.sb-mega'); }

  function close(item) {
    var panel = panelOf(item);
    if (!panel) return;
    item.classList.remove(OPEN);
    panel.hidden = true;
    var link = item.querySelector('.sb-nav__link');
    if (link) link.setAttribute('aria-expanded', 'false');
  }

  function open(item) {
    items.forEach(function (other) { if (other !== item) close(other); });
    var panel = panelOf(item);
    if (!panel) return;
    item.classList.add(OPEN);
    panel.hidden = false;
    var link = item.querySelector('.sb-nav__link');
    if (link) link.setAttribute('aria-expanded', 'true');
  }

  items.forEach(function (item) {
    var link = item.querySelector('.sb-nav__link');

    item.addEventListener('mouseenter', function () { open(item); });
    item.addEventListener('mouseleave', function () { close(item); });
    item.addEventListener('focusin', function () { open(item); });

    // On a touch screen the first tap opens the panel; the second follows the
    // link, so the group page is still reachable.
    if (link) {
      link.addEventListener('click', function (e) {
        var isOpen = item.classList.contains(OPEN);
        if (!isOpen) {
          e.preventDefault();
          open(item);
        }
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') items.forEach(close);
  });

  document.addEventListener('focusout', function (e) {
    items.forEach(function (item) {
      if (item.classList.contains(OPEN) && !item.contains(e.relatedTarget)) close(item);
    });
  });

  document.addEventListener('click', function (e) {
    items.forEach(function (item) { if (!item.contains(e.target)) close(item); });
  });
  }
})();
